import React from 'react';
import PropTypes from 'prop-types';
import './Alerts.css'; // Assuming you have some CSS for styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faTriangleExclamation, faCircleExclamation, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const iconMap = {
    success: faCircleCheck,
    error: faTriangleExclamation,
    warning: faCircleExclamation,
    info: faInfoCircle,
};

const Alert = ({ type, message }) => {
    const icon = iconMap[type] || faInfoCircle;

    return (
        <div className="d-flex justify-content-end bg-none `">
            <div className={`alert bottom-0 alert-${type}`}>
                <FontAwesomeIcon icon={icon} /> {message}
            </div>
        </div>
    );
};

Alert.propTypes = {
    type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
    message: PropTypes.string,

};

export default Alert;